import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: false,
  errorMessage: '',
  documentUploaded: false,
};

const complianceSlice = createSlice({
  name: 'compliance',
  initialState,
  reducers: {
    setLoading(state, action) {
      const { isLoading, willClearError } = action.payload;

      if (willClearError) {
        state.error = false;
        state.errorMessage = '';
      }
      state.loading = isLoading;
    },
    setError(state, action) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    setDocumentUploaded(state, action) {
      state.documentUploaded = true;
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
    clearError(state, action) {
      state.error = false;
      state.errorMessage = '';
    },
    clearCompliance: (state) => initialState,
  },
});

export const complianceActions = complianceSlice.actions;
export default complianceSlice;
